// extracted by mini-css-extract-plugin
module.exports = {"FlexDiv":"styles_FlexDiv__2TWwK","CountText":"styles_CountText__sY5Mn"};